module.exports = __webpack_public_path__ + "img/car-accident.cb599fce.svg";